window.addEventListener("load", ()=> {
    const articles = document.querySelectorAll('#ff-stream-1 .ff-stream-wrapper article');
    articles.forEach((article) => {
        const media = article.dataset.media.split(";")[2];
        if(media === undefined || !media.includes("cdninstagram.com")) return;
        console.log(media);
        const image = article.querySelector('img');
        if(!image) return;
        image.src = media;
        image.style.objectFit = "cover";
    })
});